export function isValidPhone(value) {
  const phone = value.trim();
  return /^[+0-9() .\-]+$/.test(phone) && /^\d{10,15}$/.test(phone.replace(/\D/g, ''));
}

export function validateConsultation(data) {
  const errors = {};
  for (const field of ['firstName', 'lastName', 'phone', 'email']) {
    data[field] = (data[field] || '').trim();
    if (!data[field]) errors[field] = 'This field is required.';
  }
  if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) errors.email = 'Please enter a valid email address.';
  if (data.phone && !isValidPhone(data.phone)) errors.phone = 'Please enter a valid phone number.';
  return errors;
}